<template>
  <div id="app">
		 <p class="news-title">智能匹配</p>
          <div>

             <div v-for="(item, index) in list" :key="index" icon="location-o" class="div-postion"  @click="tiao(item.id)">
            <van-cell :border="false" size="large" @click="tiao(item.id)">
            <template #title>
              <span class="">{{item.ncnicknamenc}}</span>
              <van-tag type="danger" round color="#ff8080" size="medium">&nbsp;{{item.sextext}}&nbsp;&nbsp;{{item.birthday}}岁&nbsp;</van-tag>
            </template>
            <template #label>
              <span class="">{{item.xjdaddress}}</span>
            </template>
            <template #icon>
              <img :src="item.headimgurl" alt="" class="left-img">
            </template>
            </van-cell>
            <div style="background: #FFFFFF;width: 65%;">
              <div class="xl-sg-hyzk">学历：{{item.xlname}}&nbsp;&nbsp;身高：{{item.sgname}}cm&nbsp;&nbsp;</div>
              <div class="h-10"></div>
              <div class="xl-sg-hyzk">婚姻状况：{{item.hynametext}} <span style="float: right;color: #ee0a24;">太原鹊桥会员</span></div>
              <div class="h-10"></div>
              <div class="h-15 bj-f7f7f7"></div>
            </div>
            <img v-lazy="item.picurl" class="vant-lazy" />
          </div>

<!--           
				<van-cell v-for="(list, index) in list" :key="index" class="span12 icon_img " id="" :icon="list.headimgurl"  center :title="list.nickname+list.mobile "  :label="list.create_time"  >
					<div v-if="list.vip==2" style="color: red;">已开通</div>
					<div v-else>未开通</div>
				</van-cell> -->
				
          </div>
    <div class="h-50"></div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      list: [],
    }
  },
  components: {
  },
   created:function () {
      this.$emit('footer', false);
  },
  mounted () {
    this.recordapi();
  },
	methods: {
      recordapi(){
          var that = this;
          var userid = that.$cookieStore.getCookie('userid');
          that.$api.post("/Index/memberlist",{'userid':userid}).then(res => {
            console.log(res);
            that.list = res.list;
          });
      },
      tiao(e){
        this.$router.push('Usercont?id='+e)
        console.log(e);
      },
    }
}
</script>
<style>
	.icon_img img{width: 40px;height: 40px;border-radius: 20px;}
	.icon_img .van-cell__left-icon{height: 40px !important;}
</style>


// WEBPACK FOOTER //
// src/components/MemberList.vue